/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ProjectStatusService} from "../../../Services/ProjectStatusService";

export class ProjectStatusFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			projectStatuses: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ProjectStatusService.Get()
			.then((x) => {
				this.setState({projectStatuses: x.result});
			});
	}

	@autobind
	getStatus() {
		let state = this.state.projectStatuses.find((x) => x.projectStatusId == this.props.Value);

		return state;
	}

	@autobind
	_render() {
		return this.getStatus() ? this.getStatus().name : "N/A";
	}
}